import React, { useEffect, useState, useRef } from "react";
// DirectionsRenderer को इम्पोर्ट करें और Polyline को हटा दें
import { GoogleMap, Marker, DirectionsRenderer, useJsApiLoader } from "@react-google-maps/api";
import "./orders.css";

const Orders1 = () => {
  const [bookings, setBookings] = useState([]);
  const [filteredBookings, setFilteredBookings] = useState([]);
  const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
  const [user, setUser] = useState(null);
  const [showMap, setShowMap] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [vehiclePos, setVehiclePos] = useState(null);
  // रूट डेटा को स्टोर करने के लिए नई स्टेट
  const [directionsResponse, setDirectionsResponse] = useState(null); 
  const pollingRef = useRef(null);

  const { isLoaded } = useJsApiLoader({
    // 'routes' लाइब्रेरी को लोड करना आवश्यक है
    googleMapsApiKey: "AIzaSyAw7lmyGnjx7BG2sSQ-EDwx2jKqgh0iXRc",
    libraries: ["routes"], 
  });

  const statusOptions = [
    "assigned",
    "on_the_way",
    "reached",
    "work started",
    "work completed",
  ];

  useEffect(() => {
    fetchBookings();
    const storedUser = localStorage.getItem("owner_user");
    if (storedUser) setUser(JSON.parse(storedUser));

    // Polling शुरू करें
    pollingRef.current = setInterval(fetchBookings, 10000);
    return () => clearInterval(pollingRef.current);
  }, []);

  useEffect(() => {
    if (!selectedStatusFilter) {
      setFilteredBookings(bookings);
    } else {
      setFilteredBookings(
        bookings.filter((b) => b.order_status === selectedStatusFilter)
      );
    }
  }, [selectedStatusFilter, bookings]);

  const fetchBookings = async () => {
    try {
      const res = await fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/booking.php");
      const data = await res.json();

      if (data.status === "success") {
        const activeOrders = data.data.filter(
          (b) => b.order_status !== "cancelled"
        );
        setBookings(activeOrders);
      }
    } catch (error) {
      console.error("Failed to fetch bookings:", error);
    }
  };

  // 📍 Map popup open handler
  const handleViewMap = (customerLat, customerLng, assigned_employee_id) => {
  
    setShowMap(true);

    // Customer location
    setSelectedLocation({
      lat: parseFloat(customerLat),
      lng: parseFloat(customerLng),
    });

    // Start live tracking of employee
    startLiveUpdates(assigned_employee_id, {
      lat: parseFloat(customerLat),
      lng: parseFloat(customerLng),
    });
  };

  const closePopup = () => {
    setShowMap(false);
    setSelectedLocation(null);
    setVehiclePos(null);
    setDirectionsResponse(null); // क्लोज होने पर रूट डेटा भी साफ़ करें
    // fetchBookings के लिए प्रारंभिक पोलिंग को फिर से शुरू करने के लिए
    // आपको यहाँ एक और setInterval शुरू करना होगा यदि आप चाहते हैं कि
    // मैप बंद होने के बाद ऑर्डर्स की लिस्ट अपडेट होती रहे।
    // यहाँ हम Polling को main useEffect hook के return function पर निर्भर रहने देंगे।
  };

  // 🚚 Fetch vehicle live location from backend and calculate route
  const startLiveUpdates = (assigned_employee_id, customerLocation) => {
    // पिछली पोलिंग बंद करें
    if (pollingRef.current) clearInterval(pollingRef.current);

    const interval = setInterval(async () => {
      try {
        const res = await fetch(
          `https://www.actrofiteinfotech.com/rootservices/backend/get_live_location.php?employee_id=${assigned_employee_id}`
        );
        const data = await res.json();

        if (data.status === "success" && customerLocation) {
          const empLat = parseFloat(data.location.lat);
          const empLng = parseFloat(data.location.lng);

          if (!isNaN(empLat) && !isNaN(empLng)) {
            const empPos = { lat: empLat, lng: empLng };
            setVehiclePos(empPos); // कर्मचारी की स्थिति अपडेट करें

            // ✅ Directions Service का उपयोग करके रूट की गणना करें
            if (window.google && window.google.maps && window.google.maps.DirectionsService) {
              const directionsService = new window.google.maps.DirectionsService();
            
              directionsService.route(
                {
                  origin: empPos, // कर्मचारी की वर्तमान स्थिति
                  destination: customerLocation, // ग्राहक की लोकेशन
                  travelMode: window.google.maps.TravelMode.DRIVING, // ड्राइविंग मोड
                },
                (result, status) => {
                  if (status === window.google.maps.DirectionsStatus.OK) {
                    setDirectionsResponse(result); // रूट डेटा को स्टेट में स्टोर करें
                  } else {
                    console.error(`Directions request failed due to ${status}`);
                    setDirectionsResponse(null);
                  }
                }
              );
            }
          }
        }
      } catch (err) {
        console.error(err);
      }
    }, 2000);
    pollingRef.current = interval;
  };


  return (
    <div className="orders-containerorder">
      {user && (
        <div className="orders-user-infoorder">
          <h3>Welcome, {user.username}</h3>
          <p>
            📍 {user.city}, {user.state}
          </p>
        </div>
      )}

      <h2 className="orders-headingorder">
        📦 Booking Orders ({filteredBookings.length})
      </h2>

      <label>
        Filter by Status:
        <select
          value={selectedStatusFilter}
          onChange={(e) => setSelectedStatusFilter(e.target.value)}
          className="status-dropdownorder"
        >
          <option value="">-- All Status --</option>
          {statusOptions.map((status) => (
            <option key={status} value={status}>
              {status.replace(/_/g, " ")}
            </option>
          ))}
        </select>
      </label>

      {filteredBookings.length === 0 && <p>❌ No orders found.</p>}

      {filteredBookings.map((b) => (
        <div key={b.id} className="order-cardorder">
          <div className="order-imageorder">
            <img
              src={b.image_url || b.profile_pic || "/placeholder.jpg"}
              alt="Service"
            />
          </div>

          <div className="order-contentorder">
            <div className="order-headorder">
              <strong>{b.name}</strong> | {b.email}
            </div>

            <div className="order-infoorder">
              <p>
                <strong>Service: </strong>
                {b.main_service} → {b.sub_service_title}
              </p>
              {b.address && (
                <p>
                  <strong>Booking Address: </strong> {b.address}
                </p>
              )}
             {b.latitude && b.longitude && b.order_status === "on_the_way" && (
  <p>
    <strong>Coordinates: </strong> {b.latitude}, {b.longitude}{" "}
    <button
      onClick={() =>
        handleViewMap(b.latitude, b.longitude, b.assigned_employee_id)
      }
      className="view-map-btn"
    >
      🗺️ View Map
    </button>
  </p>
)}

              <p>
                <strong>Booked At:</strong>{" "}
                {new Date(b.booked_at + " UTC").toLocaleString("en-IN", {
                  timeZone: "Asia/Kolkata",
                  hour12: true,
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </p>
              {b.phone && (
                <p>
                  <strong>Mobile:</strong> {b.phone}
                </p>
              )}
            </div>

            <div className="order-footerorder">
              <p>
                <strong>Price: </strong>
                {b.discount_price ? (
                  <>
                    <span
                      style={{
                        textDecoration: "line-through",
                        marginRight: "5px",
                      }}
                    >
                      ₹{b.original_price}
                    </span>
                    <span>₹{b.discount_price}</span>
                  </>
                ) : (
                  <span>₹{b.original_price}</span>
                )}
              </p>
              <p>
                <strong>Status: </strong>
                {b.order_status.replace(/_/g, " ")}
              </p>
              <p>
                <strong>Assigned Employee: </strong>
                {b.employee_name || "None"}
              </p>
            </div>
          </div>
        </div>
      ))}

      {/* ✅ LIVE MAP POPUP */}
      {showMap && selectedLocation && (
        <div className="map-popup-overlay" onClick={closePopup}>
          <div
            className="map-popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>🚚 Live Tracking</h3>

            {isLoaded && (
              <GoogleMap
                mapContainerStyle={{ width: "100%", height: "400px", borderRadius: "10px" }}
                zoom={13}
                // कर्मचारी की स्थिति पर मैप को केंद्रित (center) करें
                center={vehiclePos || selectedLocation} 
                mapTypeId="roadmap"
              >
                {/* DirectionsRenderer: वास्तविक सड़क का रूट दिखाता है */}
                {directionsResponse && (
                  <DirectionsRenderer
                    directions={directionsResponse}
                    options={{ 
                      suppressMarkers: true, // DirectionsRenderer के डिफ़ॉल्ट मार्कर छुपाएं
                      polylineOptions: {
                        strokeColor: "#1a73e8", // आपके मौजूदा रंग का उपयोग करें
                        strokeOpacity: 1,
                        strokeWeight: 4,
                      },
                    }}
                  />
                )}

                {/* Customer (ग्राहक) */}
                {selectedLocation && (
                  <Marker
                    position={selectedLocation}
                    label="📍"
                    title="Customer Location"
                  />
                )}

                {/* Employee (कर्मचारी) */}
                {vehiclePos && (
                  <Marker
                    position={vehiclePos}
                    icon={{
                      url: "https://cdn-icons-png.flaticon.com/512/214/214280.png",
                      scaledSize: new window.google.maps.Size(45, 45),
                    }}
                    title="Employee / Vehicle"
                  />
                )}
              </GoogleMap>
            )}

            <button className="close-map-btn" onClick={closePopup}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Orders1;